import qs from 'query-string';

import { IGetNFTRequest, IGetNFTResponse } from 'interfaces/ApiType/apiType';

import { api } from './index';

export const searchNFTsAPI = async ({
  account,
  search,
  network,
}: IGetNFTRequest): Promise<IGetNFTResponse> => {
  const url = `/account/${account}/nfts`;
  interface ParamObj {
    search?: string;
    chain?: string;
  }
  let params = <ParamObj>{ chain: 'ethereum' };
  if (search && network) params = { search, chain: network };
  if (!search && network) params = { chain: network };
  if (account) {
    const { data } = await api.get(url, {
      params,
      paramsSerializer: (param) => {
        return qs.stringify(param);
      },
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Authorization:
          typeof window !== 'undefined'
            ? `Bearer ${localStorage.getItem('token')}`
            : '',
      },
    });
    return data.nft;
  }
  return null;
};
